import AppConstants from '../config/app.constants';

let EnvironmentConfigService = function ($http, $q) {

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/environment-config/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let details = (fields) => {
        return $http
            .get(AppConstants.api + `/environment-config/details`, { params: { fields } })
            .then((res) => {
                return res.data;
            })
    }

    let update = (data) => {
        return $http
            .post(AppConstants.api + `/environment-config/update`, data)
            .then((res) => {
                return res.data;
            })
    }

    let getUIConfigs = function () {
        return $http
            .get(AppConstants.api + `/ui-configs/configs`)
            .then((res) => {
                return res.data
            })
    }

    return {
        create, 
        details,
        update,
        getUIConfigs
    }
}

EnvironmentConfigService.$inject = ["$http", "$q"];

export default EnvironmentConfigService;


// WEBPACK FOOTER //
// ./client/app/services/environment-config.service.js